import { useState } from "react";
import { toast } from "sonner";
import { http, money } from "../../lib/api";
import { apiError } from "../../context/AuthContext";
import { useAdminList, AdminHead, Field, TextInput, PrimaryBtn, inputCls } from "./adminUi";

const BLANK = { code: "", type: "percent", value: 10, min_subtotal: 0, max_uses: "", expires_at: "", active: true };

export default function AdminDiscounts() {
  const { data, reload } = useAdminList("/admin/discounts");
  const [f, setF] = useState(BLANK);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const body = (d) => ({ ...d, value: Number(d.value), min_subtotal: Number(d.min_subtotal || 0), max_uses: d.max_uses ? Number(d.max_uses) : null, expires_at: d.expires_at || null });
  const create = async (e) => {
    e.preventDefault();
    try {
      await http.post("/admin/discounts", body(f));
      toast.success("Discount created");
      setF(BLANK);
      reload();
    } catch (err) {
      toast.error(apiError(err));
    }
  };
  const toggle = async (d) => {
    await http.put(`/admin/discounts/${d.code}`, body({ ...d, active: !d.active }));
    reload();
  };
  const del = async (code) => {
    await http.delete(`/admin/discounts/${code}`);
    reload();
  };
  return (
    <div data-testid="admin-discounts">
      <AdminHead title="Discount codes" sub="Codes are validated server-side and applied in Stripe Checkout." />
      <form onSubmit={create} className="rounded-3xl bg-white shadow-sm p-6 grid sm:grid-cols-3 lg:grid-cols-6 gap-4 items-end" data-testid="discount-form">
        <Field label="Code"><TextInput required value={f.code} onChange={set("code")} placeholder="SUMMER10" data-testid="discount-form-code" /></Field>
        <Field label="Type"><select className={inputCls} value={f.type} onChange={set("type")} data-testid="discount-form-type"><option value="percent">% off</option><option value="fixed">$ off</option></select></Field>
        <Field label="Value"><TextInput type="number" step="0.01" min="0.01" required value={f.value} onChange={set("value")} data-testid="discount-form-value" /></Field>
        <Field label="Min subtotal"><TextInput type="number" step="0.01" min="0" value={f.min_subtotal} onChange={set("min_subtotal")} /></Field>
        <Field label="Max uses"><TextInput type="number" min="1" value={f.max_uses} onChange={set("max_uses")} placeholder="∞" /></Field>
        <PrimaryBtn data-testid="discount-form-save">Create</PrimaryBtn>
      </form>
      <div className="mt-6 rounded-3xl bg-white shadow-sm overflow-x-auto">
        <table className="w-full min-w-[720px] text-sm">
          <thead className="text-left text-navy/50 text-xs uppercase tracking-wider"><tr><th className="p-4">Code</th><th>Discount</th><th>Min</th><th>Uses</th><th>Status</th><th /></tr></thead>
          <tbody>
            {data?.map((d) => (
              <tr key={d.code} className="border-t border-border" data-testid={`discount-row-${d.code}`}>
                <td className="p-4 font-bold text-navy">{d.code}</td>
                <td>{d.type === "percent" ? `${d.value}% off` : `${money(d.value)} off`}</td>
                <td>{d.min_subtotal ? money(d.min_subtotal) : "—"}</td>
                <td>{d.uses}{d.max_uses ? ` / ${d.max_uses}` : ""}</td>
                <td><button onClick={() => toggle(d)} className={`rounded-full px-3 py-1 text-xs font-bold ${d.active ? "bg-emerald-100 text-emerald-800" : "bg-navy/10 text-navy/60"}`} data-testid={`discount-toggle-${d.code}`}>{d.active ? "Active" : "Paused"}</button></td>
                <td className="pr-4 text-right"><button onClick={() => del(d.code)} className="text-tpink font-semibold" data-testid={`discount-delete-${d.code}`}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && !data.length && <p className="p-8 text-center text-navy/50">No discount codes yet.</p>}
      </div>
    </div>
  );
}
